import { FC, ReactNode, useCallback, useEffect, useRef, useState } from 'react';

import { MplTopSectionHeader } from '../../organisms/MplTopSectionHeader';

import {
	Content,
	FullscreenDrawer,
	HeaderWrapper,
} from './FullscreenOverlayV2.styles';

interface IFullscreenOverlayV2Props {
	open: boolean;
	onClose: () => void;
	title: string;
	children: ReactNode;
	testId?: string;
	zIndex?: number;
}

const SCROLL_SHADOW_THRESHOLD = 50;
const DEFAULT_Z_INDEX = 1000;

export const FullscreenOverlayV2: FC<IFullscreenOverlayV2Props> = ({
	open,
	onClose,
	title,
	children,
	testId = 'fullscreenOverlayV2',
	zIndex = DEFAULT_Z_INDEX,
}) => {
	const [isScrolled, setIsScrolled] = useState(false);
	const contentRef = useRef<HTMLDivElement>(null);

	const handleScroll = useCallback((e: Event) => {
		const scrollTop = (e.target as HTMLElement).scrollTop;
		setIsScrolled(scrollTop > SCROLL_SHADOW_THRESHOLD);
	}, []);

	useEffect(() => {
		const el = contentRef.current;
		if (!el || !open) return;

		el.addEventListener('scroll', handleScroll, true);
		return () => el.removeEventListener('scroll', handleScroll, true);
	}, [open, handleScroll]);

	return (
		<FullscreenDrawer
			anchor="left"
			open={open}
			onClose={onClose}
			hideBackdrop
			sx={{ zIndex }}
			data-testid={testId}
		>
			<HeaderWrapper withShadow={isScrolled}>
				<MplTopSectionHeader title={title} onBack={onClose} />
			</HeaderWrapper>
			{open && <Content ref={contentRef}>{children}</Content>}
		</FullscreenDrawer>
	);
};
